import React, { Fragment, useContext } from 'react';
import { array, func, string } from 'prop-types';
import { AppContext } from '../AppContext';
import googleMaps from '../../api/googleMaps';

function Hotels({ country, filtered, setHasHotels, setNumberOfHotels, destinationMap }) {
  const { onClick } = useContext(AppContext);

  function destionnationMap(e) {
    let markerId = e.target.parentElement.getAttribute('data-marker-id');
    let targetMarker;
    if (googleMaps.markers && googleMaps.markers.length > 0) {
      targetMarker = googleMaps.markers.filter((marker) => {
        if (marker.id == markerId) {
          return true;
        }
      })
    }
    if (targetMarker.length > 0) {
      let map = googleMaps.returnMapInstance();
      map.panTo(targetMarker[0].getPosition());
      //map.panBy(-20, -80);
      google.maps.event.trigger(targetMarker[0], 'click');
    }
  }

  //group by continent, country and city

  const grouped = new Object();
  let hotelTotal = 0;

  for (let item of filtered) {
    let continent = item.continent;
    let country = item.country;
    let city = item.city;
    let hotel_code = item.code;
    if (!grouped[continent]) {
      grouped[continent] = {};
    }
    if (!grouped[continent][country]) {
      grouped[continent][country] = {};
    }
    if (!grouped[continent][country][city]) {
      grouped[continent][country][city] = {};
    }
    if (!grouped[continent][country][city][hotel_code] && item.data) {
      grouped[continent][country][city][hotel_code] = item;
      hotelTotal++;
    }
  }

  const sorted = Object.keys(grouped).sort()
    .map(function (continent, indexContinent) {
      const countries = Object.keys(grouped[continent]).sort()
        .map(function (country, indexCountry) {
          const cities = Object.keys(grouped[continent][country]).sort().map(function (city, indexCity) {
            const hotel = Object.keys(grouped[continent][country][city]).sort().map(function (code, indexHotel) {
              let item = grouped[continent][country][city][code];
              return (
                <div key={indexHotel}
                  class="cell"
                >
                  <button
                    onClick={(destinationMap) ? onClick : destionnationMap}
                    className="find-a-hotel-suggestion suggestion"
                    style={{ textAlign: 'left' }}
                    data-marker-id={item.indexHotel}
                    aria-label={`${item.value}`}
                  >
                    <span>{item.value}</span>
                    <div className="autocomplete-group">{item.data.location.replace(/,\s?,/g, ',')}</div>
                  </button>
                </div>
              );
            });
            return (
              <Fragment
                key={indexCity}
                class="cell"
              >
                <div
                  class="cell"
                  style={{ breakInside: 'avoid-column' }}
                >
                  <div
                    style={{ fontWeight: 'bolder' }}
                  >
                    {city}
                  </div>
                  {hotel[0]}
                </div>
                {hotel.slice(1)}
              </Fragment>
            );
          });
          return (
            <Fragment
              key={indexCountry}
            >
              <div
                class="cell result-block"
              >
                <div
                  class="country-title"
                >
                  {country}
                </div>
                {(cities[0])}
              </div>
              {cities.slice(1)}
            </Fragment>
          );
        });
      return (
        <div
          key={indexContinent}
          className="cell grid-x"
        >
          <div class="cell continent-title">
            {continent}
          </div>
          <div className="cell result-list">
            {countries}
          </div>
        </div>
      );
    });

  if (setHasHotels && sorted.every(hotel => hotel === null)) {
    setHasHotels(false);
  }

  if (setNumberOfHotels) {
    setNumberOfHotels(hotelTotal);
  }

  // if country prop is present, return this block
  if (country && hotelTotal > 0) {
    return (
      <div className="hotels-group">
        <p className="country-name">{country} properties</p>
        {sorted}
      </div>
    );
  }

  // default return sorted hotels
  return sorted;
}

Hotels.propTypes = {
  country: string,
  filtered: array.isRequired,
  setHasHotels: func
};

Hotels.defaultProps = {
  destinationMap: true,
}

export default Hotels;